module.exports = __webpack_public_path__ + "static/media/loading-spinner.91ce87e9.svg";